import type { ComplianceOverviewCounts, ComplianceOverviewItem, ComplianceOverviewListQuery, Page } from '@chukua/common';
import { api } from '../../shared/shared.api';
import { toListParams } from '../../shared/policies/list-params';

export function listComplianceOverview(query: ComplianceOverviewListQuery): Promise<Page<ComplianceOverviewItem>> {
  return api<Page<ComplianceOverviewItem>>(`/compliance/overview?${toListParams(query)}`);
}

/** The count tile for the future dashboard (gitaumoses4/chukua#18) — not consumed by a dashboard screen yet, only this page's own summary. */
export function getComplianceOverviewCounts(): Promise<ComplianceOverviewCounts> {
  return api<ComplianceOverviewCounts>('/compliance/overview/counts');
}
